import React from "react";
import "./PhotoGrid.css";

// Импортируем все изображения
const importAll = (r) => r.keys().map(r);
const images = importAll(
  require.context(
    "../../assets/images/photo-grid/",
    false,
    /\.(png|jpe?g|svg)$/
  )
);

const PhotoGrid = () => {
  return (
    <section className="photo-grid">
      {images.map((image, index) => (
        <img
          key={index}
          className="photo-grid__element"
          src={image}
          alt={`Фото природы России ${index + 1}`}
          loading="lazy"
        />
      ))}
    </section>
  );
};

export default PhotoGrid;
